module.exports = __webpack_public_path__ + "static/media/lykkeLogoLarge.d1c6e12a.svg";